<template>
    <div>
        <b-button
            variant="warning"
            @click.stop="abrirModal()"
            :disabled="valorDisponivel <= 0"
        >
            <span>
                <i class="fa fa-plus mr-2"></i> Inserir Dotação Orçamentária
            </span>
        </b-button>
        <dotacao-form
            :mostrarModal="mostrarModal"
            @modalFechado="mostrarModal = false"
            :valorTotal="valorTotal"
            :valorDisponivel="valorDisponivel"
            @inserirRateio="$emit('inserirRateio', $event)"
        ></dotacao-form>
    </div>
</template>

<script>
import DotacaoForm from './DotacaoForm'

export default {
    components: {
        DotacaoForm
    },

    props: {
        valorTotal: {
            type: Number,
            default: () => 0
        },

        valorDisponivel: {
            type: Number,
            default: () => 0
        },

        tipo: {
            type: String
        },

        disabled: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            mostrarModal: false
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
